<main class="music-page">
  <header class="page-heading">
    <div>
      <p class="eyebrow">Library</p>
      <h1>Music</h1>
    </div>
    <button
      mat-icon-button
      type="button"
      (click)="loadAlbums()"
      [disabled]="albumsLoading"
      aria-label="Refresh music library"
      matTooltip="Refresh library">
      <mat-icon [class.spinning]="albumsLoading">refresh</mat-icon>
    </button>
  </header>

  <section class="player" aria-label="Music player">
    <div class="now-playing">
      <div class="current-cover">
        <img *ngIf="currentCoverUrl; else currentCoverPlaceholder" [src]="currentCoverUrl" alt="" />
        <ng-template #currentCoverPlaceholder>
          <mat-icon aria-hidden="true">album</mat-icon>
        </ng-template>
      </div>
      <div class="track-details">
        <span>{{ playbackLabel }}</span>
        <strong>{{ status?.song?.title || 'Nothing playing' }}</strong>
        <small>{{ status?.song?.artist || currentAlbum?.name || 'Select an album' }}</small>
      </div>
    </div>

    <div class="transport-controls">
      <button
        mat-icon-button
        type="button"
        (click)="playPrevious()"
        [disabled]="!canSkipTrack || controlInProgress"
        aria-label="Previous track"
        matTooltip="Previous">
        <mat-icon>skip_previous</mat-icon>
      </button>
      <button
        mat-fab
        color="primary"
        type="button"
        class="play-button"
        (click)="togglePlayback()"
        [disabled]="!canControlPlayback || controlInProgress"
        [attr.aria-label]="isPlaying ? 'Pause playback' : 'Play music'"
        [matTooltip]="isPlaying ? 'Pause' : 'Play'">
        <mat-icon>{{ controlInProgress ? 'hourglass_empty' : (isPlaying ? 'pause' : 'play_arrow') }}</mat-icon>
      </button>
      <button
        mat-icon-button
        type="button"
        (click)="playNext()"
        [disabled]="!canSkipTrack || controlInProgress"
        aria-label="Next track"
        matTooltip="Next">
        <mat-icon>skip_next</mat-icon>
      </button>
    </div>

    <div class="player-summary">
      <button
        type="button"
        class="connection-state"
        (click)="refreshStatus()"
        [disabled]="statusLoading || controlInProgress">
        <span class="connection-dot" [class.connected]="isConnected"></span>
        {{ statusLoading ? 'Checking MPD' : (isConnected ? 'MPD connected' : 'MPD disconnected') }}
      </button>
      <span>{{ status?.playlistLength ?? 0 }} in queue</span>
    </div>

    <div class="timeline">
      <span>{{ formatTime(status?.elapsed) }}</span>
      <div class="timeline-track" aria-hidden="true">
        <span [style.width.%]="playbackProgress"></span>
      </div>
      <span>{{ formatTime(status?.duration) }}</span>
    </div>
  </section>

  <div class="error-banner" role="alert" *ngIf="playerError">
    <mat-icon>error_outline</mat-icon>
    <span>{{ playerError }}</span>
    <button mat-icon-button type="button" (click)="refreshStatus()" aria-label="Retry MPD connection">
      <mat-icon>refresh</mat-icon>
    </button>
  </div>

  <section class="library" aria-labelledby="album-library-heading">
    <header class="library-heading">
      <div>
        <h2 id="album-library-heading">Albums</h2>
        <span>{{ albums.length }} {{ albums.length === 1 ? 'album' : 'albums' }}</span>
      </div>
    </header>

    <div class="error-banner" role="alert" *ngIf="libraryError">
      <mat-icon>folder_off</mat-icon>
      <span>{{ libraryError }}</span>
      <button mat-icon-button type="button" (click)="loadAlbums()" aria-label="Retry loading albums">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>

    <div class="library-loading" *ngIf="albumsLoading">
      <mat-spinner diameter="28"></mat-spinner>
      <span>Loading albums</span>
    </div>

    <div class="empty-library" *ngIf="!albumsLoading && !libraryError && albums.length === 0">
      <mat-icon>library_music</mat-icon>
      <strong>No albums found</strong>
    </div>

    <div class="album-grid" *ngIf="!albumsLoading && albums.length > 0">
      <button
        type="button"
        class="album-card"
        *ngFor="let album of albums"
        (click)="playAlbum(album)"
        [class.active]="activeAlbumId === album.id"
        [class.pending]="pendingAlbumId === album.id"
        [disabled]="controlInProgress"
        [attr.aria-label]="'Play album ' + album.name">
        <span class="album-cover">
          <img
            *ngIf="coverUrls[album.id]; else albumCoverPlaceholder"
            [src]="coverUrls[album.id]"
            [alt]="album.name + ' cover'"
            loading="lazy" />
          <ng-template #albumCoverPlaceholder>
            <span class="cover-placeholder">
              <mat-icon aria-hidden="true">album</mat-icon>
            </span>
          </ng-template>
          <span class="cover-action" aria-hidden="true">
            <mat-icon>{{ pendingAlbumId === album.id ? 'hourglass_empty' : (activeAlbumId === album.id && isPlaying ? 'volume_up' : 'play_arrow') }}</mat-icon>
          </span>
        </span>
        <span class="album-copy">
          <strong>{{ album.name }}</strong>
          <span>{{ albumTrackLabel(album) }}</span>
        </span>
      </button>
    </div>
  </section>
</main>
